import type React from "react";
import type { Channel } from "@/types/channel";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Edit2, Trash2 } from "lucide-react";
import { useState } from "react";
import { EditChannelDialog } from "./EditChannelDialog";
import { DeleteChannelDialog } from "./DeleteChannelDialog";

interface ChannelTableProps {
	channels: Channel[];
}

export const ChannelTable: React.FC<ChannelTableProps> = ({ channels }) => {
	const [editingChannel, setEditingChannel] = useState<Channel | null>(null);
	const [deletingChannel, setDeletingChannel] = useState<Channel | null>(null);

	return (
		<>
			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>名前</TableHead>
						<TableHead>説明</TableHead>
						<TableHead>種類</TableHead>
						<TableHead>作成日</TableHead>
						<TableHead className="w-[100px]">操作</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{channels.map((channel) => (
						<TableRow key={channel.id}>
							<TableCell className="font-medium">
								{channel.emoji} {channel.name}
							</TableCell>
							<TableCell>{channel.description}</TableCell>
							<TableCell>
								{channel.type === "ANNOUNCEMENT" ? "お知らせ" : "一般"}
							</TableCell>
							<TableCell>
								{new Date(channel.createdAt).toLocaleDateString("ja-JP")}
							</TableCell>
							<TableCell>
								<div className="flex space-x-2">
									<Button
										variant="ghost"
										size="sm"
										onClick={() => setEditingChannel(channel)}
									>
										<Edit2 className="h-4 w-4" />
									</Button>
									<Button
										variant="ghost"
										size="sm"
										onClick={() => setDeletingChannel(channel)}
									>
										<Trash2 className="h-4 w-4" />
									</Button>
								</div>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>

			<EditChannelDialog
				channel={editingChannel}
				open={!!editingChannel}
				onOpenChange={(open) => !open && setEditingChannel(null)}
			/>

			<DeleteChannelDialog
				channel={deletingChannel}
				open={!!deletingChannel}
				onOpenChange={(open) => !open && setDeletingChannel(null)}
			/>
		</>
	);
};
